import { axiosApi as axios } from '../helpers/axiosApi';
import { getCookie } from './helpers';
const REGISTRY_API = "/studies/global-registries/";

export const getAllGlobalRegistries = () => {
  return axios.get(REGISTRY_API).then(res => {
    return res.data.data;
  });
};

export const addGlobalRegistry = (name, url) => {
    let payload = {
      name,
      url
    }
    return axios.post(REGISTRY_API, payload, {
      headers: {
        "Authorization": `Bearer ${getCookie('access')}`
      }
    }).then(res => {
      return res.data;
    });
  };

export const updateGlobalRegistry = (id, body) => {
  return axios.put(`${REGISTRY_API}${id}/`, body, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
};

export const deleteGlobalRegistry = (id, data) => {
  return axios.delete(`${REGISTRY_API}${id}/`, {
    data: data,
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res;
  })
};
